import React, { useState } from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import './corporateTravel.css';
import { useNavigate } from 'react-router-dom';



const CorporateTravel = () => {
     const navigate = useNavigate();
   
      const navigateTotechCBT = () => {
        navigate('/tech-platform', { state: { scrollTo: 'TechCBT' } });
    };
    const navigateTotechApp = () => {
        navigate('/tech-platform', { state: { scrollTo: 'TechApp' } });
    };

    return (
        <>
            <div
                className="corporate-travel"
               
            >
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 mt-md-5 pt-3">
                            <div className="box d-flex mt-5 mb-2 position-relative">
                                <div className="man-image">
                                    <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/corporateMan.png" alt="" loading="lazy"  />
                                </div>
                                <div className="CT-content p-md-4 p-2 pe-md-5">
                                    
                                    <div className="comp-icon position-absolute top-0 d-flex justify-content-end d-lg-block d-none">
                                        <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/icons/compIcon.png" alt="" className="h-100 " loading="lazy" />
                                    </div>
                                    <h2 className="headings">Booking Platform for Your Unique Needs</h2>
                                    <p className="mt-md-2 grotesk-headings ">In a rush for your next business meeting? Don’t miss out on our specialized corporate travel booking platform, specially designed to help businesses simplify their travel arrangements efficiently. Whether it’s about flight bookings, airport pick-ups, or car rentals, our system empowers employees to book and oversee travel plans while adhering to budget limits.</p>
                                    <div className="carouselCaption text-black">
                                        <a href="/tech-platform">
                                        <button onClick={navigateTotechCBT}
                                            className="btn text-dark fs5 p-md-3 pb-md-2 pt-md-2 fw-bold mt-md-3">FIND
                                            OUT MORE</button>
                                            </a>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-12 d-flex mt-3  mb-5">
                            <div className="box2 d-flex mt-md-5 mt-3 mb-5 position-relative">
                                <div className="CT-content p-md-4 p-2 ps-md-4">
                                    <div className="mob-icon2 position-absolute top-0 start-0 d-lg-block d-none">
                                        <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/icons/mobIcon.png" alt="" className="h-100"  loading="lazy" />
                                    </div>
                                    <h2 className="headings px-lg-5">Your Personalized Travel Companion</h2>
                                    <p className="mt-md-2 px-lg-5 grotesk-headings ">Are you a solo or corporate traveler? We are thrilled to offer a specialized mobile app that enhances your travel experience with personalized services, real-time information, and convenience. Enjoy custom-made recommendations, real-time price comparison, expense tracking, travel support, and a lot more to make it convenient for you.</p>
                                    <div className="carouselCaption text-black px-lg-5 mt-0 mt-md-4 pt-md-2 corporateButton">
                                        <a href="/tech-platform">
                                        <button  onClick={navigateTotechApp}
                                            className="btn text-dark fs5 mt-md-0 p-md-3 pb-md-2 pt-md-2  fw-bold">FIND
                                            OUT MORE</button>
                                            </a>
                                    </div>
                                </div>
                                <div className="grp-image">
                                    <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/IMG%2001.png" alt="" className=" h-100"  loading="lazy" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            {/* <!-- .............................tour-section.................................... --> */}
            <div className="tour-section mb-5 h-auto w-100 pb-3">
                <div className="container">
                    <div className="row">
                        <div className="d-flex flex-md-row flex-column">
                            <div className="col-md-8 col-12 mt-md-3 mt-4 pt-md-3">
                                <div className="text text-white d-flex justify-content-center">
                                    <p className="tourtext grotesk-headings">Take a Tour of Blueberry Travels Global Travel Solutions</p>
                                </div>
                            </div>
                            <div className="col-md-4 col-12 p-2 mt-md-3">
                                <div className="carouselCaption">
                                    <a href="/global-solution">
                                    <button className="btn text-white explorebtn grotesk-headings fw-bold">EXPLORE
                                        MORE
                                        HERE</button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default CorporateTravel